import store from './store/store';
import {
    FirebaseContext,
    FirebaseProvider
} from './config/configureFirebase';
import * as authactions from './actions/authactions';
import * as bookingactions from './actions/bookingactions';
import * as bookinglistactions from './actions/bookinglistactions';
import * as cancelreasonactions from './actions/cancelreasonactions';
import * as cartypeactions from './actions/cartypeactions';
import * as estimateactions from './actions/estimateactions';
import * as driverearningaction from './actions/driverearningaction';
import * as earningreportsaction from './actions/earningreportsaction';
import * as notificationactions from './actions/notificationactions';
import * as promoactions from './actions/promoactions';
import * as usersactions from './actions/usersactions';
import * as settingsactions from './actions/settingsactions';
import * as paymentactions from './actions/paymentactions';
import * as tripactions from './actions/tripactions';
import * as taskactions from './actions/taskactions';
import * as locationactions from './actions/locationactions';
import * as chatactions from './actions/chatactions';
import * as withdrawactions from './actions/withdrawactions';
import * as DateFunctions from './other/DateFunctions';
import * as GoogleAPIFunctions from './other/GoogleAPIFunctions';
import * as GeoFunctions from './other/GeoFunctions';
import * as languageactions from './actions/languageactions';
import * as addressactions from './actions/addressactions';
import * as NotificationFunctions from './other/NotificationFunctions';
import * as caractions from './actions/caractions';
import * as smtpactions from './actions/smtpactions';
import * as smsactions from './actions/smsactions';
import countries from './other/GetCountries';
import * as sosctions from './actions/sosaction';
import * as complainactions from './actions/complainactions';
import * as applogactions from './actions/applogactions';
import * as userreportactions from './actions/userreportactions';
import * as driverarrivingactions from './actions/driverarrivingactions';
import * as tripShareActions from './actions/tripShareActions';
import * as usedreferralaction from "./actions/usedreferralaction";
import * as fetchFleetAdminEarnings from "./actions/fleetadminearningaction";
import * as vietnameseFunctions from './other/vietnameseFunctions';
import * as BonusReferralaction from "./actions/referralBonusactions";
import * as Withdrareferaction from "./actions/withdraw_refer";
import * as zonificacionactions from "./actions/zonificacionactions";
import * as networkSlots from "./other/networkSlots";
import * as leaderWeekly from "./other/leaderWeekly";
import * as leaderAlertactions from "./actions/leaderAlertactions";
import * as fareMarketAdvisoractions from "./actions/fareMarketAdvisoractions";
import * as reportsactions from "./actions/reportsactions";
import * as promoFunctions from "./other/promoFunctions";
import * as walletcampaignactions from "./actions/walletcampaignactions";
import * as walletCampaignFunctions from "./other/walletCampaignFunctions";
import * as performanceMonitor from './utils/performanceMonitor';
import * as currencyFormat from './other/currencyFormat';
import * as womenOnlyService from './other/womenOnlyService';
import * as roundTrip from './other/roundTrip';
import * as driverBidChips from './other/driverBidChips';
import * as customerCities from './other/customerCities';
import * as idDocumentRejection from './other/idDocumentRejection';
import * as mapFreeCars from './other/mapFreeCars';
import * as mapTripCity from './other/mapTripCity';
import { CLEAR_OLD_REFERRALS } from "./store/types";
import { unsubscribeReferralListListener } from "./actions/usedreferralaction";
import { unsubscribeReferralBonusListener } from "./actions/referralBonusactions";

// Memory cleanup actions
const memoryCleanupActions = {
    clearOldBookings: () => ({ type: 'CLEAR_OLD_BOOKINGS' }),
    clearOldNotifications: () => ({ type: 'CLEAR_OLD_NOTIFICATIONS' }),
    clearOldMessages: () => ({ type: 'CLEAR_OLD_MESSAGES' }),
    clearOldReferrals: () => (dispatch) => {
        unsubscribeReferralListListener();
        unsubscribeReferralBonusListener();
        dispatch({ type: CLEAR_OLD_REFERRALS });
    }
};

const api = {
    ...authactions,
    ...bookingactions,
    ...bookinglistactions,
    ...cancelreasonactions,
    ...cartypeactions,
    ...estimateactions,
    ...driverearningaction,
    ...earningreportsaction,
    ...notificationactions,
    ...promoactions,
    ...usersactions,
    ...settingsactions,
    ...paymentactions,
    ...tripactions,
    ...taskactions,
    ...locationactions,
    ...addressactions,
    ...chatactions,
    ...withdrawactions,
    ...DateFunctions,
    ...GoogleAPIFunctions,
    ...GeoFunctions,
    ...languageactions,
    ...NotificationFunctions,
    ...caractions,
    ...complainactions,
    ...applogactions,
    ...userreportactions,
    ...driverarrivingactions,
    ...tripShareActions,
    ...smtpactions,
    ...smsactions,
    ...sosctions,
    ...usedreferralaction,
    ...fetchFleetAdminEarnings,
    ...BonusReferralaction,
    ...Withdrareferaction,
    ...zonificacionactions,
    ...vietnameseFunctions,
    ...memoryCleanupActions,
    ...networkSlots,
    ...leaderWeekly,
    ...leaderAlertactions,
    ...fareMarketAdvisoractions,
    ...reportsactions,
    ...promoFunctions,
    ...walletcampaignactions,
    ...walletCampaignFunctions,
    ...currencyFormat,
    ...womenOnlyService,
    ...roundTrip,
    ...driverBidChips,
    ...customerCities,
    ...idDocumentRejection,
    ...mapFreeCars,
    ...mapTripCity,
    countries: countries
};

export {
    FirebaseContext,
    FirebaseProvider,
    store,
    api,
    performanceMonitor,
    currencyFormat,
    mapFreeCars,
    mapTripCity
}
